<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="115px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="合同编码" prop="code">
              <el-input :disabled="model == 'edit' || model == 'view'" clearable v-model="form.code"
                placeholder="请输入合同编码" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="签订日期" prop="signTime">
              <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd" :disabled="model === 'view'"
                v-model="form.signTime" type="date" placeholder="请选择签订日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同开始日期" prop="startTime">
              <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd" :disabled="model === 'view'"
                v-model="form.startTime" :picker-options="startPickerOptions" type="date" placeholder="请选择合同开始日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同结束日期" prop="endTime">
              <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd" :disabled="model === 'view'"
                v-model="form.endTime" :picker-options="endPickerOptions" type="date" placeholder="请选择合同开始日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否包房" prop="isCharteredRoom">
              <el-radio-group :disabled="model != 'sign'" v-model="form.isCharteredRoom">
                <el-radio :label="'1'">否</el-radio>
                <el-radio :label="'2'">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="床位" prop="bedId">
              <el-input disabled v-if="model != 'sign'" clearable v-model="form.bedName"
                placeholder="请选择床位" maxlength="30"></el-input>
              <!-- <el-select style="width:100%;" v-else v-model="form.bedId" :value="form.bedId" placeholder="请选择床位"
                clearable ref="addConnectSelect">
                <el-option :value="form.bedId" show-all-levels :label="form.bedName">
                  <el-tree :props="treeProps" :load="editAreaLazyLoadTree" lazy @node-click="editAreaNodeTreeClick_">
                  </el-tree>
                </el-option>
              </el-select> -->

              <el-select clearable :value="form.bedId" placeholder="床位" v-else ref="addConnectSelect"
                style="width: 100%;">
                <el-option :value="form.bedId" show-all-levels :label="form.bedName">
                  <el-tree node-key="id" :data="treeFormData" :props="treeProps" @node-click="typeNodeTreeClick">
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件">
              <!-- <VUploadDrag :disabled="model == 'view'" :max="20 * 1024 * 1024" :limit="10"
                :fileList.sync="form.attachList" /> -->
              <VUploadDrag :limit="10" :disabled="model == 'view'" :max="20971520" :fileList.sync="form.attachList">
              </VUploadDrag>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="title">收费信息</div>
      <el-button size="mini" type="primary" icon="el-icon-plus" @click="handleAdd" style="margin: 10px 0 20px"
        v-if="model != 'view'">新增</el-button>
      <el-table border :data="paramList" style="width: 100%" :header-cell-style="{ color: '#000' }">
        <el-table-column type="index" label="#" align="center" fixed width="50"> </el-table-column>
        <el-table-column prop="feeType" label="收费项目">
          <template slot-scope="scope">
            <span v-if="model == 'view'">{{ scope.row.feeTypeName }}</span>
            <el-select v-else v-model="scope.row.feeType" @change="changeFeeType(scope.$index, scope.row)"
              style="width: 100%" placeholder="收费项目">
              <el-option v-for="item in itemTypeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="feeMonth" label="月单价">
          <template slot-scope="scope">
            <span v-if="model == 'view'">{{ scope.row.feeMonth }}</span>
            <!-- <el-input v-else v-model="scope.row.feeMonth" placeholder="" maxlength="10"></el-input> -->
            <money-input @input="calculateTotalPrice(scope.$index, scope.row)" v-else v-model="scope.row.feeMonth"
              clearable placeholder="" style="width: 100%" />
          </template>
        </el-table-column>
        <el-table-column prop="monthNum" label="数量/月份">
          <template slot-scope="scope">
            <span v-if="model == 'view'">{{ scope.row.monthNum }}</span>
            <el-input @input="calculateTotalPrice(scope.$index, scope.row)" v-else v-model="scope.row.monthNum"
              clearable placeholder=""></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="fee" label="费用">
          <template slot-scope="scope">
            <span v-if="model == 'view'">{{ scope.row.fee }}</span>
            <!-- <el-input v-else v-model="scope.row.fee" clearable placeholder=""></el-input> -->
            <money-input v-else v-model="scope.row.fee" clearable placeholder="" style="width: 100%" />
          </template>
        </el-table-column>
        <el-table-column align="center" width="80" v-if="model != 'view'">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDel(scope.$index, scope.row)"
              circle></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        保存
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common.js';
import { generateRandomString } from '@/util/util.js';
// import VUploadDrag from '@/views/components/v-upload-drag';
import VUploadDrag from "@/views/components/v-upload";
import { dateFormat } from '@/util/date';
import {
  saveSign,
  saveRenew,
  monthlyUnitPrice,
  contractupdate,
  treeNursingAll,
  treeNursingList,
  treeListDetail,
  contractDetail
} from '../../api/serveItemManage';
export default {
  components: { VUploadDrag },
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'sign',
    },
    isContract: {
      default: false,
    }
  },
  data() {
    return {
      // 树的节点属性
      treeProps: {
        label: 'name',
        value: 'id',
        children: 'childList',
        // isLeaf: (data) => {
        //   return data.nextType == this.leafType;
        // },
      },
      treeFormData: [],
      leafType: -1,
      itemTypeList: [],
      form: {
        code: '',
        signTime: '',
        startTime: '',
        endTime: '',
        isCharteredRoom: '',
        bedId: '',
        bedName: '',
        attachList: [],
      },
      paramList: [],
      monthDiff: 0,
      startPickerOptions: {
        disabledDate(time) {
          return false;
        }
      },
      endPickerOptions: {
        disabledDate(time) {
          // 如果没有选择开始日期，则不禁用任何日期
          if (!this.startTime) {
            return false;
          }
          // 禁止选择开始日期之前的日期
          return time.getTime() < new Date(this.form.startTime).getTime();
        }
      },
      formRules: {
        code: [{ required: true, message: '合同编码不能为空', trigger: 'blur' }],
        signTime: [{ required: true, message: '签订日期不能为空', trigger: 'change' }],
        startTime: [{ required: true, message: '合同开始日期不能为空', trigger: 'change' }],
        endTime: [{ required: true, message: '合同结束日期不能为空', trigger: 'change' }],
      },
    };
  },
  created() {
    this.initData();
    console.log(this.row, '触发了created');
  },
  mounted() { },
  watch: {
    'form.startTime'(newVal, oldVal) {
      this.calculateMonthDiff();
      this.endPickerOptions.disabledDate = (time) => {
        return time.getTime() < new Date(newVal).getTime();
      };
    },
    'form.endTime'(newVal, oldVal) {
      this.calculateMonthDiff();
    },
    'form.isCharteredRoom'(newVal, oldVal) {
      treeNursingAll({ nursinghomeId: this.row.nursinghomeId,isCharteredRoom: newVal}).then(({ data }) => {
        this.treeFormData = data;
      });
    },
  },
  methods: {
    async initData() {
      getDictionary('nursinghome_fee_type').then((res) => {
        this.itemTypeList = res.data;
      })
      if (this.model == 'sign') {
        this.form.code = generateRandomString()
        this.form.startTime = dateFormat(new Date()).split(' ')[0]
        this.form.isCharteredRoom = '1'
      } else {
        contractDetail({ id: this.isContract ? this.row.contractId : this.row.id }).then((res) => {
          if (this.model == 'renew') {
            this.form.code = generateRandomString()
            this.form.startTime = res.data.endTime.split(' ')[0]
            this.form.bedId = res.data.bedId
            this.form.bedName = res.data.bedName
            this.form.isCharteredRoom = res.data.isCharteredRoom ? res.data.isCharteredRoom.toString() : '1'
            this.startPickerOptions.disabledDate = (time) => {
              return time.getTime() < new Date(this.form.startTime).getTime();
            };
          } else {
            this.form = res.data
            this.form.isCharteredRoom = this.form.isCharteredRoom ? this.form.isCharteredRoom.toString() : '1'
            this.form.signTime = res.data.signTime ? res.data.signTime.split(' ')[0] : ''
            this.form.startTime = res.data.startTime ? res.data.startTime.split(' ')[0]: ''
            this.form.endTime = res.data.endTime ? res.data.endTime.split(' ')[0]: ''
            this.paramList = this.form.feeList || []
            this.paramList.forEach(item => {
              item.feeType = item.feeType.toString()
              item.monthNum = item.monthNum && Number(item.monthNum) >= 0 ? Number(item.monthNum) : 0
            })
          }
        })
      }
    },

    findObjectById(array, id) {
      // 遍历数组
      for (let i = 0; i < array.length; i++) {
        const item = array[i];
        if (item.id === id) {
          return item;
        }
        if (item.childList && Array.isArray(item.childList)) {
          const found = this.findObjectById(item.childList, id);
          if (found) {
            return found;
          }
        }
        return null;
      }
    },

      changeFeeType(index, val) {
        if (val) {
          let params = {
            isCharteredRoom: this.form.isCharteredRoom,
            bedId: this.form.bedId,
            feeType: val.feeType,
          }
          monthlyUnitPrice(params).then((res) => {
            this.paramList[index].feeMonth = res.data ? Number(res.data) : 0;
            this.calculateTotalPrice(index, this.paramList[index]);
          });
        }
      },

      calculateMonthDiff() {
        let startDate = new Date(this.form.startTime);
        let endDate = new Date(this.form.endTime);
        let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
        months += endDate.getMonth() - startDate.getMonth();
        if (endDate.getDate() < startDate.getDate() && endDate.getMonth() !== startDate.getMonth()) {
          months--;
        }
        this.monthDiff = months;
      },

      calculateTotalPrice(rowIndex, row) {
        // 计算总价
        row.fee = Number(row.feeMonth) * Number(row.monthNum)
        // 为了触发视图更新，可能需要重新为 row 赋值
        this.$set(this.paramList, rowIndex, { ...row });
      },

      // 树加载完毕
      editAreaLazyLoadTree(node, resolve) {
        let id;
        if (node.level === 0) {
          return resolve([
            { name: this.row.nursinghomeName, id: this.row.nursinghomeId, nextType: 0 },
          ]);
        } else {
          id = node.data.id;
        }
        if (node.level === 5) {
          resolve({});
          return;
        }
        treeNursingList().then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.nextType = !item.nextType;
            });
          } else {
          }
          resolve(data);
        });
      },

      editAreaNodeTreeClick_(node) {
        setTimeout(() => {
          console.log(node);
          if (parseInt(node.nodeType) == 1) {
            return;
          }
          let nodeId = node.id;
          let nodeTitle = node.name;
          treeListDetail({ id: nodeId }).then((res) => {
            this.$set(this.form, 'bedId', res.data.id);
            this.$set(this.form, 'bedName', res.data.name);
            this.form = this._.cloneDeep(this.form);
            if (res.data.name) {
              this.$refs.addConnectSelect.blur();
            }
          });
        }, 0);
      },

      typeNodeTreeClick(node) {
        console.log(node);
        if (node.childList.length == 0) {
          this.form.bedName = node.name;
          this.form.bedId = node.id;
        }
      },

      handleAdd() {
        this.paramList.push({
          feeType: '',
          feeMonth: '',
          monthNum: this.monthDiff && this.monthDiff <= 0 ? 0 : this.monthDiff,
          fee: '',
        });
      },

      handleDel(index) {
        this.paramList.splice(index, 1);
      },
      saveRecord() {
        // if (this.paramList.length === 0) {
        //     return this.$message.warning('请添加收费信息');
        //   }
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            const hasEmptyFields = this.paramList.some(item => !item.feeType);
            if (hasEmptyFields) {
              return this.$message.warning('收费项目为必填项,请检查后再保存');
            }
            let params = { nursinghomeId: this.row.nursinghomeId, elderlyId: this.isContract ? this.row.id : this.row.elderlyId, ...this.form }
            params.feeList = this.paramList
            params.signTime = params.signTime ? params.signTime + ' 00:00:00' : ''
            params.startTime = params.startTime ? params.startTime + ' 00:00:00' : ''
            params.endTime = params.endTime ? params.endTime + ' 23:59:59' : ''
            params.monthNum = this.monthDiff
            let fn = this.model == 'sign' ? saveSign : this.model == 'renew' ? saveRenew : contractupdate
            fn(params).then((res) => {
              this.$message.success('操作成功！');
              if (this.model == 'sign' && params.bedId) {
                this.$confirm('是否同时办理入住?', '提示', {
                  confirmButtonText: '是',
                  cancelButtonText: '否',
                  type: 'warning',
                })
                  .then(() => {
                    this.$emit('success', 'toMove', params);
                  })
                  .catch(() => {
                    this.$emit('success');
                  });
              } else {
                this.$emit('success');
              }
            });
          }
        });
      },
      cancleRecord() {
        this.$emit('cancle');
      },
    },
  };
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

::v-deep .el-col-8 {
  height: 54px;
}

.title {
  line-height: 50px;
  font-weight: bolder;
  font-size: 18px;
  margin-bottom: 10px;
}

::v-deep .el-form-item__error {
  position: absolute !important;
}
</style>
